import style from "styles/style.scss";

export enum Breakpoint {
    SM = parseInt(style.breakpointSm),
    MD = parseInt(style.breakpointMd),
    LG = parseInt(style.breakpointLg),
    XL = parseInt(style.breakpointXl),
    XXL = parseInt(style.breakpointXxl),
}
